import api from "./axios";

const UploadService = {
	uploadImage: async (file) => {
		try {
			// Create form data to send the file
			const formData = new FormData();
			formData.append("file", file);

			const response = await api.post("/uploads/image", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			return response.data;
		} catch (error) {
			console.error("Error uploading image:", error);
			throw error;
		}
	},

	deleteImage: async (url) => {
		try {
			if (!url) return false;
			const response = await api.delete("/uploads/image", {
				data: { url },
			});
			return response.data.success;
		} catch (error) {
			console.error("Error deleting image:", error);
			return false;
		}
	},
};

export default UploadService;
